import React, { useEffect, useState } from "react";
import axios from "axios";
import TypingAnimation from "../TypingAnimation";
import { ConversationStep } from "../../interfaces";
import { sendNewLead } from "../../util";
// import { useAppDispatch } from "../../store/hooks";
import { trackEvent } from "../../store/analytics/action";
import { useAppDispatch } from "../../store/hooks";

const { REACT_APP_WEBSOCKET_URL, REACT_APP_SHOP_URL } = process.env;

interface IProps {
    step?: ConversationStep;
    values?: any;
    triggerNextStep?: (data?: {
        currentStep: ConversationStep;
        value?: string | number;
        trigger: string;
    }) => void;
}
const AppointmentTelephoneCall: React.FC<IProps> = ({ values, step, triggerNextStep }) => {
    const dispatch = useAppDispatch();
    const [connectionId, setConnectionId] = useState("");

    const listenToSocket = async (event: any) => {
        const body = JSON.parse(event.data);

        if (body?.type === "connectionId") {
            setConnectionId(body?.connectionId);
            await callClient();
            await sendNewLead(values, step?.theme!);
            triggerNextStep!({
                currentStep: step!,
                trigger: step!.trigger,
            });
        }
    };

    const callClient = async () => {
        try {
            await axios.post(`${REACT_APP_SHOP_URL}/api/v1/shop/client/call`, {
                phoneNumber: values?.applicant1_contactNumber,
                apiKey: step?.theme?.apiKey,
                connectionId,
            });
            dispatch(
                trackEvent({
                    telephone: true,
                })
            );
        } catch (err) {
            console.log("err");
        }
    };

    useEffect(() => {
        // const ws = new WebSocket(REACT_APP_WEBSOCKET_URL!);
        // ws.onmessage = listenToSocket;
        /*eslint-disable react-hooks/exhaustive-deps*/
    }, []);

    return (
        <div className="conversation-message-bubble">
            <TypingAnimation theme={step?.theme!} type="bot" />
            <div className="conversation-message-bubble-text">
                Perfect. I'm giving you a call now.
            </div>
        </div>
    );
};

export default React.memo(AppointmentTelephoneCall);
